import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import LocationListsPage from './pages/LocationListsPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { apiService } from './services/apiService';

function App() {
  const [configurationLoading, setConfigurationLoading] = useState(true);

  useEffect(() => {
    async function initializeApp() {
      try {
        await apiService.loadConfiguration();
      } catch (error) {
        console.error('Failed to initialize app configuration:', error);
      } finally {
        setConfigurationLoading(false);
      }
    }
    
    initializeApp();
  }, []);

  // Show loading screen while configuration is being loaded
  if (configurationLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2
      }}>
        <CircularProgress size={48} />
        <Typography variant="body1" color="text.secondary">
          Loading configuration...
        </Typography>
      </Box>
    );
  }

  return (
    <AuthProvider>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh' 
      }}>
        <Header />
        
        <Box component="main" sx={{ 
          flexGrow: 1, 
          backgroundColor: 'background.default',
          py: 3 
        }}>
          <Routes>
            <Route 
              path="/" 
              element={
                <ProtectedRoute fallback={<HomePage />}>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/location-lists" 
              element={
                <ProtectedRoute>
                  <LocationListsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              } 
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Box>
        
        <Footer />
      </Box>
    </AuthProvider>
  );
}

export default App;
